import { FC } from 'react';
import { Select, SelectProps, TreeSelect, TreeSelectProps } from 'antd';
import classNames from 'classnames';
import style from './index.module.less';
import ArrowDownSvg from '@/assets/imgs/arrow_down.svg?react';

export type CustomTreeSelectProps = TreeSelectProps;

const CustomTreeSelect: FC<CustomTreeSelectProps> = ({ className, ...restProps }) => {
  const isFlatTree = restProps.treeData?.every((item) => !item.children || item.children.length === 0);
  return (
    <TreeSelect
      maxTagCount={10}
      suffixIcon={<ArrowDownSvg />}
      className={classNames(style.customSelect, className)}
      classNames={{
        root: isFlatTree ? style.flatTree : '',
        ...restProps.classNames,
      }}
      fieldNames={{
        value: 'value', 
        label: 'label'
      }}
      allowClear
      {...restProps}
    />
  );
};

export default CustomTreeSelect;
